// Aura Charm on the client: the odds the viewer rolls right now, and the small mark on a creature caught under one.
import { auraOneInAt } from '../shared/auracharm.ts';
import type { CreatureDTO } from '../shared/protocol.ts';
import { S, serverNow } from './state.ts';
import { ICON } from './icons.ts';

/** Aura odds (1 in n) on the viewer's own hunt catches now: halved while an Aura Charm runs. */
export function auraOneInNow(): number {
  return auraOneInAt(S.trainer?.boosts, serverNow());
}

/** A subtle mark for a creature caught under an Aura Charm; empty for a plain catch. */
export function boostMark(c: Pick<CreatureDTO, 'boosted'>): string {
  return c.boosted ? `<span class="ac-mark ac-${c.boosted}" data-boosted="${c.boosted}" title="Aura Charm · ${c.boosted}" aria-label="Aura Charm, ${c.boosted}">${ICON.aura}</span>` : '';
}
